module.exports = __webpack_public_path__ + "static/media/time.d278ee56.png";